/*
 * @Descripttion:
 * @version:
 * @Author: jizhijun
 * @Date: 2020-05-09 11:57:09
 * @LastEditors: jizhijun
 * @LastEditTime: 2020-05-13 09:49:24
 */
export default function deviceMixin(hybrid) {
  var hybridJs = hybrid;
  var innerUtil = hybridJs.innerUtil;
  hybridJs.extendModule('device', [{
    // 获取设备信息
    namespace: 'getDeviceId',
    os: ['ywk']
  }, {
    // 获取网络状态
    namespace: 'getNetWorkInfo',
    os: ['ywk']
  }, {
    // 打电话
    namespace: 'callPhone',
    os: ['ywk'],
    params: {
      phoneNum: ''
    },
    runCode: function runCode() {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      } // 兼容字符串形式


      var args = innerUtil.compatibleStringParamsToObject.call(this, rest, 'phoneNum');
      hybridJs.callInner.apply(this, args);
    }
  }, {
    // 发短信
    namespace: 'sendMsg',
    os: ['ywk'],
    params: {
      phoneNum: '',
      message: ''
    },
    runCode: function runCode() {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      } // 兼容字符串形式


      var args = innerUtil.compatibleStringParamsToObject.call(this, rest, 'phoneNum', 'message');
      hybridJs.callInner.apply(this, args);
    }
  }, {
    // 关闭键盘
    namespace: 'closeInputKeyboard',
    os: ['ywk']
  }, {
    // 振动
    namespace: 'vibrate',
    os: ['ywk'],
    params: {
      duration: 500
    },
    runCode: function runCode() {
      var rest = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
      } // 兼容字符串形式


      var args = innerUtil.compatibleStringParamsToObject.call(this, rest, 'duration');
      hybridJs.callInner.apply(this, args);
    }
  }, {
    // 获取客户端桥注入状态
    namespace: 'ready',
    os: ['ywk']
  }, {
    // 注册android系统返回按键
    namespace: 'hookSysBack',
    os: ['ywk']
  }]);
}